/* eslint-disable import/prefer-default-export */
export const changePasswordInitialValues = {
  currentPassword: '',
  password: '',
  passwordConfirmation: '',
};
